<template>
  <div v-if="Object.keys(allData).length" class="report-13" dir="rtl">
    <div style="margin-top: 200px" v-if="pathLogo == m"></div>

    <div class="mlogo">
      <img class="wlogo" :src="pathLogo" />
    </div>
    <div style="direction: initial" class="md-layout mt-25">
      <div style="text-align: center" class="md-layout-item md-size-100">
        <h3 class="text-center">{{ name }}</h3>
        <h4 class="text-center">{{ desc }}</h4>
      </div>

      <div class="md-layout-item md-size-100 mt-25">
        <div class="text-center" style="direction: ltr; display: flex">
          <!-- <h4 style="margin-top: -10px" class="text-center">
            الكشف التحليلى لشهر
            <p>{{ month }}</p>
          </h4> -->
        </div>
      </div>

      <div class="md-layout-item md-size-100">
        <h4 class="text-left">
          تاريخ الطباعة :
          <span class="display: inline-block">{{ date }}</span>
        </h4>
      </div>
    </div>
    <!-- <img class="report-logo" src="/img/ns.png" alt="" /> -->
    <!-- <header class="report-header">
      <div class="title">
        <h2 class="text-center">{{ name }}</h2>
        <h2 class="text-center">{{ desc }}</h2>
      </div>
      <div class="dates">
        <div>
          <p>الكشف التحليلى لشهر :</p>
          <p>{{ month }}</p>
        </div>
        <div>
          <p>تاريخ الطباعة :</p>
          <p>{{ date }}</p>
        </div>
      </div>
    </header> -->
    <section class="analytical-detection-body">
      <div class="head">
        <p class="salary text-center">المرتب الأساسى والعلاوات</p>
        <p class="discount text-center">الخصميات</p>
      </div>
      <div class="sub-head">
        <div class="sub-salary">
          <div class="loop">
            <p>الأساسى</p>
            <p>اللجان</p>
            <p>المكافأت</p>
            <p>العمل الإضافى</p>
          </div>
          <div class="loop">
            <p v-for="(item, i) in allData.allowances" :key="'key' + i">
              {{ item.key }}
            </p>
          </div>
          <!-- <div>
            <p>علاوات أخرى</p>
            <p>مكافأة</p>
          </div> -->
        </div>
        <div class="sub-discount">
          <div>
            <p>ضمان</p>
            <p>تضامن</p>
          </div>
          <div>
            <p>جهاد</p>
            <p>دخل</p>
          </div>
          <!-- <div>
            <p>دينار</p>
            <p>الدمغة</p>
          </div> -->
          <div>
            <p>خ.عقوبة</p>
            <p>غياب</p>
          </div>
          <div>
            <p>نفقة شرعية</p>
            <p>ق.سلفة</p>
          </div>
          <div>
            <p>اخرى</p>
            <p>تأمين طبى</p>
          </div>
        </div>
      </div>
      <div class="sub-body">
        <div class="sub-salary">
          <div class="loop">
            <p>{{ addCommasToNumber(allData.totalBasicSalaries) }}</p>
            <p>{{ addCommasToNumber(allData.totalCommitteesAllownace) }}</p>
            <p>{{ addCommasToNumber(allData.totalRewards) }}</p>
            <p>{{ addCommasToNumber(allData.totalOverTime) }}</p>
          </div>
          <div class="loop">
            <p v-for="(item, i) in allData.allowances" :key="'value' + i">
              {{ item.value }}
            </p>
          </div>
        </div>
        <div class="sub-discount">
          <div>
            <p>{{ addCommasToNumber(allData.totalWarrantyTax) }}</p>
            <p>{{ addCommasToNumber(allData.totalSolidarityTax) }}</p>
          </div>
          <div>
            <p>{{ addCommasToNumber(allData.totalJihadTax) }}</p>
            <p>{{ 0 }}</p>
          </div>
          <!-- <div>
            <p>{{ allData.totalDinarTax }}</p>
            <p>{{ allData.totalStampTax }}</p>
          </div> -->
          <div>
            <p>{{ 0 }}</p>
            <p>{{ addCommasToNumber(allData.totalAbsanceDiscount) }}</p>
          </div>
          <div>
            <p>{{ addCommasToNumber(allData.totalLegalExpenseDiscount) }}</p>
            <p>{{ addCommasToNumber(allData.totalCreditDiscount) }}</p>
          </div>
          <div>
            <p>{{ addCommasToNumber(allData.totalOtherDiscounts) }}</p>
            <p>{{ 0 }}</p>
          </div>
        </div>
      </div>
    </section>
    <section class="analytical-detection-result">
      <div class="right-result">
        <p>عدد الموظفين</p>
        <div class="staff-number text-center">{{ allData.employeesCount }}</div>
        <div class="all">
          <p>إجمالى المرتبات</p>
          <!-- <p>علاوة بالصافى</p> -->
        </div>
        <div class="result">
          <p>{{ addCommasToNumber(allData.totalSalaries) }}</p>
          <!-- <p>{{ allData.totalAllowances }}</p> -->
        </div>
      </div>
      <div class="left-result">
        <p>الاستقطاعات</p>
        <p>{{ addCommasToNumber(allData.totalDiscounts) }}</p>
        <p>الصافى</p>
        <div class="pure text-center">
          {{ addCommasToNumber(allData.totalNetSalaries) }}
        </div>
      </div>
    </section>
    <section class="analytical-detection-details">
      <div class="first"></div>
      <div class="second">
        <p>تفصيل العلاوات الاخرى والخصميات الاخرى</p>
        <div
          style="
            display: flex;
            padding-top: 0px;
            padding-bottom: 0px;
            justify-content: space-around;
          "
        >
          <p style="flex: 0 0 50%">فروق مرتب</p>
          <p>{{ addCommasToNumber(allData.totalAllownacesDifferences) }}</p>
        </div>
        <div
          style="
            display: flex;
            padding-top: 0px;
            padding-bottom: 0px;
            justify-content: space-around;
          "
        >
          <p style="flex: 0 0 50%">مرتب سابق</p>
          <p>{{ addCommasToNumber(allData.totalDifferences) }}</p>
        </div>
      </div>
    </section>
    <section class="bosses">
      <p>رئيس قسم الحسابات</p>
      <p>المراجعة الداخلية</p>
      <p>المراقب المالى</p>
    </section>
    <section class="final-result">
      <div class="right">
        <div class="t-header">
          <p>الخصميات</p>
          <p>المعتمد</p>
          <p>المصروف</p>
          <p>الرصيد</p>
          <p>صفحة سجل الاعتماد</p>
        </div>

        <div class="t-body">
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
        </div>
        <div class="t-body">
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
        </div>
        <div class="t-body">
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
        </div>
        <div class="t-body">
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
        </div>
      </div>
      <div class="left">
        <div>
          <p>حصة جهة العمل</p>
          <p>{{ addCommasToNumber(allData.totalEmployerTax) }}</p>
        </div>
        <div>
          <p>حصة الخزينة</p>
          <p>{{ addCommasToNumber(allData.totalCabinetTax) }}</p>
        </div>
        <hr />
        <hr />
        <div>
          <p>المجموع % 15.375</p>
          <p>
            {{
              addCommasToNumber(
                allData.totalEmployerTax + allData.totalCabinetTax
              )
            }}
          </p>
        </div>
        <hr />
        <hr />
        <div>
          <p>عدد الموقوفين</p>
          <p>{{ allData.suspendedCount }}</p>
        </div>
        <div>
          <p>مرتبات الموقوفين</p>
          <p>{{ addCommasToNumber(allData.suspendedSalaries) }}</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import env from "../../../env";

export default {
  props: ["month", "date", "name", "desc", "allData", "pathLogo"],
  mounted() {},
  data() {
    return {
      m: env.mTop(),
    };
  },
  methods: {
    round(value, precision) {
      var multiplier = Math.pow(10, precision || 0);
      return Math.round(value * multiplier) / multiplier;
    },

    addCommasToNumber(number) {
      let numString = this.round(number, 3).toString();
      numString = numString.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return numString;
    },
  },
};
</script>

<style lang="scss" scoped>
.t-body p {
  height: 50px;
}
@import "../../assets/css/report-13";
</style>
